import { Suspense, useEffect, useState } from 'react';
import { Canvas } from '@react-three/fiber';
import { useGLTF } from '@react-three/drei';

import { LightAndShadow } from './SceneComponents/LigthAndShadow.jsx';
import { CityEnvironment, Seasons, Fountains } from './SceneComponents/CityEnvironment.jsx';
import { CustomControls } from './SceneComponents/CustomControls.jsx';
import { LocationSkyboxVideo } from './SceneComponents/LocationSkybox.jsx';
import { DEFAULT_SCENE_MEDIA, VIEW_MODE } from './SceneComponents/VideoConfig.jsx';

import { LocationNames, Locations } from './SceneComponents/Location.jsx';
import { UI } from './LayoutComponents/UI.jsx';
import { getHourNormalized } from './LayoutComponents/DaytimePlayer.jsx';
import { useControls } from 'leva';
import { DEFAULT_SKYBOX_AUDIO_SRC, SkyboxAudioPlayer } from './SceneComponents/SkyboxAudioPlayer.jsx';
import DialogBox from './LayoutComponents/Dialogbox.jsx';

export function Scene({ gyroSettings,  initialSceneMedia}) {
	const [camSpeed, setCamSpeed] = useState(0.125);
	const [needsReset, setNeedsReset] = useState(true);
	const [sceneMedia, setSceneMedia] = useState(initialSceneMedia || DEFAULT_SCENE_MEDIA);

	
	return <>
	{/* 2. Place the audio player outside the Canvas (it's standard HTML, not 3D) */}
	
		<SkyboxAudioPlayer 
                audioSrc={sceneMedia.audioSrc} 
                playAudio={true} 
		/>
		<Canvas
			shadows
			camera={{ near: 0.1, far: 20000 }}
		>
		<CustomControls
			gyroSettings={gyroSettings} 
			needsReset={needsReset} setNeedsReset={setNeedsReset}
			heading={sceneMedia.initialHeading}
		/>

		<Suspense fallback={null}>
                <LocationSkyboxVideo 
                    src={sceneMedia.videoSrc} 
                    viewMode={sceneMedia.viewMode} 
                />
		</Suspense>
		</Canvas>

		<UI
			sceneMedia={sceneMedia} setSceneMedia={setSceneMedia}    
                
		/>
	</>
}
